import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import { db, setDoc,doc, getDoc , collection, getDocs, query, where,deleteDoc } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const PendidikSubtes = () => {
    const [data, setData] = useState([]); // State untuk menyimpan daftar kelas
    const [pembelajaran, setPembelajaran] = useState([]); // State untuk menyimpan daftar kelas

    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [filteredRombel, setFilteredRombel] = useState([]);
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const [isLoadingAwal, setLoadingAwal] = useState(true);

    const [formData, setFormData] = useState({
        pembelajaran_id: "",
        id_ujian: "",
        id_rombel: "",
        id_mapel: "",
        nama_mapel: "",
        nama_rombel: "",
        durasi: "",
        guru_id: "",
        nama_guru: ""

    }); // State untuk menyimpan daftar kelas
    const [isEditing, setIsEditing] = useState(false);

    const getDataRefrensi = useCallback(async () => {


       try {
                // Kirim request ke server dengan header level user
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/getsubtes`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();
                
                // Menyimpan data kelas ke dalam state
                setPembelajaran(data.data.pembelajaran); 

                setData(data.data.ujian);
            } catch (error) {
                setError(error.message || 'Something went wrong');
            }
    }, []);

    useEffect(()  => {
        getDataRefrensi();

        // const authToken = localStorage.getItem('authToken');

        // if (!authToken) {
            
        //     return; // Jika tidak ada token, hentikan eksekusi
        // }

        // try {
        //     // Decode payload dari token JWT
        //     const decoded = jwtDecode(authToken);
        //     setInformasiAkun(decoded); // Simpan informasi akun ke state
            
        //     // Pastikan fetchUjian & getDataRefrensi ada sebelum dipanggil
        //     if (decoded.data_id) {
        //         fetchUjian(decoded.data_id);
        //         console.log(decoded.data_id)
        //     }
        //     //getDataRefrensi();
        // } catch (error) {
        //     console.error("Error decoding token:", error);
        //     navigate("/login"); // Jika token tidak valid, arahkan ke halaman login
        // }

       
    }, []);
    // useEffect(() => {

    //     // Pastikan DataTable hanya diinisialisasi sekali
    //     if (data.length > 0) {
    //         // Hancurkan DataTable jika sudah ada sebelum inisialisasi ulang
    //         if ($.fn.dataTable.isDataTable('.table')) {
    //             $('.table').DataTable().destroy(); // Menghancurkan DataTable yang lama
    //         }

    //         // Inisialisasi DataTable
    //         $('.table').DataTable({
    //             "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>", // Add 'B' in the appropriate position
    //             "language": {
    //                 "search": "",
    //                 "lengthMenu": "_MENU_"
    //             },
    //         });
    //     }


    // }, [data]); // Inisialisasi ulang hanya ketika `kelas` berubah

    useEffect(() => {
        if (formData.id_mapel) {
            // Ambil semua pembelajaran yang sesuai dengan mapel yang dipilih
            const pembelajaranFiltered = pembelajaran?.filter(
                (item) => item.mata_pelajaran_id === formData.id_mapel
            );

            // Ambil semua rombel yang sesuai dengan pembelajaran tersebut
            const rombelIds = pembelajaranFiltered.map((item) => item.mata_pelajaran_id);
            const rombelFiltered = pembelajaran?.filter((rombel) =>
                rombelIds.includes(rombel.mata_pelajaran_id)
            );
            console.log(rombelFiltered)

            setFilteredRombel(rombelFiltered);
        } else {
            setFilteredRombel([]); // Reset jika tidak ada mapel yang dipilih
        }
    }, [formData.id_mapel, data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Jika select option yang berubah, simpan juga nama yang dipilih
        if (name === "id_rombel") {
            const selectedRombel =pembelajaran?.find((r) => String(r.rombongan_belajar_id) ===  String(value));
            
            setFormData({
                ...formData,
                id_rombel: value,
                nama_rombel: selectedRombel ? selectedRombel.nama_rombel : "",
                pembelajaran_id: selectedRombel ? selectedRombel.pembelajaran_id : ""
            });
        } else if (name === "id_mapel") {
            const selectedMapel = pembelajaran?.find((m) => String(m.mata_pelajaran_id) ===  String(value));
            setFormData({
                ...formData,
                id_mapel: value,
                nama_mapel: selectedMapel ? selectedMapel.nama_mapel : "",
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        
    };

    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
        console.log(ujian)
    };

    // Reset form untuk tambah data baru
    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            pembelajaran_id: "",
            id_ujian: "",
            id_rombel: "",
            id_mapel: "",
            nama_mapel: "",
            nama_rombel: "",
            durasi: ""
        });
    };
    const generateRandomId = () => {
        return Math.random().toString(36).substring(2, 7).toUpperCase(); // 5 karakter (huruf + angka)
    };
    
    // Fungsi untuk memastikan ID unik
    const getUniqueId = async (collectionName) => {
        let uniqueId;
        let exists = true;
    
        while (exists) {
            uniqueId = generateRandomId(); // Buat ID acak
            const docRef = doc(db, collectionName, uniqueId);
            const docSnap = await getDoc(docRef);
    
            if (!docSnap.exists()) {
                exists = false; // ID belum ada, bisa digunakan
            }
        }
        return uniqueId;
    };
    const handleSaveSoal = async (e) => {
        e.preventDefault();
        

         try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputSubtes`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                        },
                        body: JSON.stringify(formData),
                    });
        
                    if (!response.ok) {
                        throw new Error("Gagal menyimpan data");
                    }
        
                    const result = await response.json();
                    Swal.fire("Berhasil!", result.message, "success");
                   
                    setError('');
                    setFormData({
                        rombel_id: "",
                        initial: "",
                        nama_rombel: "",
                        tingkat: "10",
                        jenis_rombel: "Umum"
                    });
        
                    window.location.reload();
        
                } catch (error) {
                    Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
               
                    setError(error.response?.data?.message || 'Something went wrong');
                }
    };
    const handleDeleteSoal = async (ujianId) => {
        if (!ujianId) {
            alert("ID soal tidak valid.");
            return;
        }
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Soal yang dihapus tidak bisa dikembalikan!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteDoc(doc(db, "ujian", ujianId));
    
                    Swal.fire("Terhapus!", "Soal berhasil dihapus.", "success");
    
                    window.location.reload();
                } catch (error) {
                    console.error("Terjadi kesalahan saat menghapus soal:", error);
                    Swal.fire("Error!", "Gagal menghapus soal.", "error");
                }
            }
        });
    };
    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Evaluasi / Ujian</h3></div>

                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                    </div>
                                    <hr />
                                    {data.length>0 ? (<table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Kode</th>
                                                <th scope="col">Mapel / Kelas</th>
                                               
                                                <th width="50"><center>Soal</center></th>
                                                <th width="50"><center>Durasi</center></th>
                                                <th width="50"><center> Hasil</center></th>
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((item, index) => (
                                                <tr key={'pml' + index}>
                                                    <td scope="row">{index + 1}</td>
                                                    <td><b>{item.id}</b></td>
                                                    <td><b>{item.nama_mapel}</b>
                                                    
                                                    <p>{item.nama_rombel}</p></td>

                                                   
                                                    <td><center>
                                                        {/* {JSON.parse(item.soal).length} */}
                                                        </center></td>
                                                  
                                                    <td><center>{item.durasi}</center></td>
                                                    <td> <a href={`/pendidik/hasilujian?kode=${item.id}`} className="avtar avtar-xs mx-1 btn-link-secondary" title='Hasil'><center>Hasil</center></a></td>
                                                    <td>
                                                        <a href={`/pendidik/viewevaluasi?id_ujian=${item.id}`} title='Tambah dana Lihat Soal' className="avtar avtar-xs mx-1 btn-link-secondary">
                                                            <i className="ti ti-eye f-20"></i>
                                                        </a>
                                                        {/* <a data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={() => handleEdit(item)} href="#" className="avtar avtar-xs mx-1 btn-link-secondary"><i className="ti ti-edit f-20"></i> </a> */}
                                                        {/* <a href="#" onClick={() => handleDeleteSoal(item.id_ujian)} className="avtar avtar-xs mx-1 btn-link-danger"><i className="ti ti-trash f-20"></i></a> */}
                                                        
                                                        </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                   ): (
                                                                           <Skeleton count={5} height={20} />
                                                                         )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSaveSoal} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {isEditing ? "Edit Pembelajaran" : "Tambah Pembelajaran"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {/* Pilihan Mapel */}
                            <div className="mb-3">
                                <label className="form-label">Nama Tes</label>
                                <input name='nama' className="form-control" type="test" placeholder="Nama" value={formData.nama} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Mapel / Mata Pelajaran</label>
                                <select
                                    name="id_mapel"
                                    className="form-select"
                                    value={formData.id_mapel}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Pilih Mapel</option>
                                    {pembelajaran?.map((itemmapel, index) => (
                                        <option key={`mpl-${index}`} value={itemmapel.mata_pelajaran_id}>
                                            {itemmapel.nama_mapel}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Pilihan Rombel yang difilter berdasarkan Mapel */}
                            <div className="mb-3">
                                <label className="form-label">Rombel / Kelas</label>
                                <select
                                    name="id_rombel"
                                    className="form-select"
                                    value={formData.id_rombel}
                                    onChange={handleChange}
                                    required
                                    disabled={!formData.id_mapel} // Matikan jika mapel belum dipilih
                                >
                                    <option value="">Pilih Rombel</option>
                                    {filteredRombel.length > 0 ? (
                                        filteredRombel.map((itemrombel, index) => (
                                            <option key={`rm-${index}`} value={itemrombel.rombongan_belajar_id}>
                                                {itemrombel.nama_rombel}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>-- Tidak ada rombel tersedia --</option>
                                    )}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Durasi Tes</label>
                                <input name='durasi' className="form-control" type="number" placeholder="Durasi" value={formData.durasi} onChange={handleChange} />
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    );
};

export default PendidikSubtes;
